import { MarketData } from './types';
import { AxiosInstance } from '../../../utilities/requestClient';

/** GET /markets-snapshot/:positionDate/ */
export const getMarketsSnapshot = async (
  positionDate: string,
): Promise<MarketData[]> => {
  const { data } = await AxiosInstance.get<MarketData[]>(
    `markets-snapshot/${positionDate}/`,
  );
  return data ?? [];
};
